import React from "react";

export default function SupplierTerms() {
  return (
    <div
      style={{ marginLeft: "10px" }}
      className="h-min-height-100p h-width-100p b-content-wrapper"
    >
      <div className="container">
        <div className="h-bg-white h-pv-15 h-ph-15 h-mv-20 b-static-page">
          <div className="h-p-20">
            <div className="h-bg-white h-pv-15 h-ph-15">
              <h1 style={{ color: "#FF6A00" }}>TERMS & CONDITIONS</h1>

              {/* 1 */}
              <h3 style={{ color: "#FF6A00" }}>1. Introduction</h3>
              <p>
                Welcome to Ant Technology’s B2B E-Commerce Platform (“the
                Platform”), operated by Ant Technology Plc (“Ant”, “we”, “us”,
                or “our”).
              </p>
              <p>
                By registering and using our platform or any related services,
                you (“User”, “you”, or “your”) agree to comply with these Terms
                and Conditions and any related policies.
              </p>
              <p>
                This Terms and Conditions document applies to all Suppliers
                (businesses or entities that sell products or services through
                the platform).
              </p>
              <p>
                By registering, listing products, or transacting on the
                platform, you agree to comply with these Terms and all related
                company policies.
              </p>

              {/* 2 */}
              <h3 style={{ color: "#FF6A00" }}>
                2. Eligibility and Account Registration
              </h3>
              <ul>
                <li>
                  Users must be legally registered businesses or licensed
                  service providers in Ethiopia or regions where Ant operates.
                </li>
                <li>
                  Users must provide valid business registration documents, Tax
                  Identification Number (TIN), and contact details.
                </li>
                <li>
                  Users agree to maintain accurate and up-to-date account
                  information.
                </li>
                <li>
                  Ant reserves the right to verify, suspend, or terminate
                  accounts that provide misleading or fraudulent information.
                </li>
              </ul>

              {/* 3 */}
              <h3 style={{ color: "#FF6A00" }}>3. Platform Use and Conduct</h3>
              <p>
                All users agree to use the platform lawfully, responsibly, and
                in good faith.
              </p>
              <ul>
                <li>
                  Use the platform for illegal, misleading, or unethical
                  activities
                </li>
                <li>
                  Upload or transmit harmful, offensive, or infringing content
                </li>
                <li>
                  Circumvent payment systems or contractual obligations
                </li>
                <li>
                  Misuse intellectual property or confidential information
                </li>
              </ul>
              <p>
                Ant reserves the right to monitor activities, investigate
                complaints, and take corrective actions including suspension or
                termination.
              </p>

              {/* 4 */}
              <h3 style={{ color: "#FF6A00" }}>4. Supplier Obligations</h3>
              <ul>
                <li>
                  Provide accurate, truthful, and complete product details
                  including pricing, stock levels, and specifications
                </li>
                <li>
                  Fulfill confirmed orders promptly and with agreed quality
                  standards
                </li>
                <li>
                  Ensure goods comply with Ethiopian trade, safety, and consumer
                  protection laws
                </li>
                <li>
                  Ethical conduct is mandatory; selling counterfeit, expired,
                  or unauthorized goods is prohibited
                </li>
              </ul>

              {/* 5 */}
              <h3 style={{ color: "#FF6A00" }}>5. Pricing & Commissions</h3>
              <ul>
                <li>
                  Ant B2B charges a commission of 5%–10% per successful
                  transaction depending on category
                </li>
                <li>
                  Commissions are deducted automatically during settlement
                </li>
                <li>
                  Payments are released within 2–5 business days after
                  confirmed delivery via AntPay, Telebirr, or M-Pesa
                </li>
              </ul>

              {/* 6 */}
              <h3 style={{ color: "#FF6A00" }}>6. Inventory Management</h3>
              <ul>
                <li>
                  Suppliers must maintain real-time stock updates
                </li>
                <li>
                  Accepting orders without available stock is prohibited
                </li>
                <li>
                  Repeated stock-related failures may result in suspension or
                  penalties
                </li>
              </ul>

              {/* 7 */}
              <h3 style={{ color: "#FF6A00" }}>
                7. Supplier Ratings and Conduct
              </h3>
              <ul>
                <li>
                  Ant may implement rating systems to assess supplier
                  reliability and professionalism
                </li>
                <li>
                  Feedback and ratings are used to measure trustworthiness
                </li>
              </ul>

              {/* 8 */}
              <h3 style={{ color: "#FF6A00" }}>
                8. Intellectual Property Rights
              </h3>
              <ul>
                <li>
                  Suppliers grant Ant a limited, non-exclusive right to display
                  product images, trademarks, and branding for operational and
                  marketing purposes
                </li>
                <li>
                  Suppliers retain ownership of their trademarks and branding
                </li>
                <li>
                  All platform software and content belong to Ant Technology
                  Plc
                </li>
              </ul>

              {/* 9 */}
              <h3 style={{ color: "#FF6A00" }}>
                9. Account Suspension & Termination
              </h3>
              <ul>
                <li>
                  Non-compliance, fraud, false disputes, or repeated complaints
                </li>
                <li>
                  Continuous misuse such as fake stock or order delays
                </li>
                <li>
                  Suppliers may request account closure with 15-day written
                  notice, subject to clearing obligations
                </li>
              </ul>

              {/* 10 */}
              <h3 style={{ color: "#FF6A00" }}>
                10. Data Privacy and Confidentiality
              </h3>
              <ul>
                <li>
                  Ant complies with Ethiopian data protection and cybersecurity
                  regulations
                </li>
                <li>
                  Supplier data is used strictly for operational and marketing
                  purposes
                </li>
                <li>
                  Data is shared only with consent or legal obligation
                </li>
              </ul>

              {/* 11 */}
              <h3 style={{ color: "#FF6A00" }}>
                11. Limitation of Liability
              </h3>
              <ul>
                <li>Indirect or consequential losses</li>
                <li>Service interruptions or third-party failures</li>
                <li>Losses from inaccurate user-provided information</li>
              </ul>
              <p>
                Ant’s total liability shall not exceed the service fees earned
                from the affected transaction.
              </p>

              {/* 12 */}
              <h3 style={{ color: "#FF6A00" }}>12. Amendments</h3>
              <p>
                Ant reserves the right to modify these Terms periodically.
                Continued use constitutes acceptance of updated terms.
              </p>

              {/* 13 */}
              <h3 style={{ color: "#FF6A00" }}>
                13. Governing Law & Dispute Resolution
              </h3>
              <ul>
                <li>
                  Disputes shall first be resolved through amicable negotiation
                </li>
                <li>
                  Unresolved disputes shall be referred to arbitration in Addis
                  Ababa under Ethiopian Arbitration Law
                </li>
                <li>
                  These Terms are governed by Ethiopian commercial and digital
                  trade laws
                </li>
              </ul>

              {/* 14 */}
              <h3 style={{ color: "#FF6A00" }}>14. Acceptance</h3>
              <p>
                By clicking “Agree” or using Ant’s services, you acknowledge
                that you have read, understood, and accepted these Terms and
                Conditions in full.
              </p>

              <b>Last updated: March 2025</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
